if (!window.Eurus.loadedScript.has('cart-noti.js')) {
  window.Eurus.loadedScript.add('cart-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartNoti', {
        enable: false,
        mode: 'toast',
        listItem: [],
        items: [],
        show: false,
        loading: false,
        itemCount: 0,
        totalPrice: 0,
        currency: 'USD',
        cartUrl: '/cart',
        engravingVariantId: null,
        laserArtworkFeeVariantId: null,
        freeShippingEnabled: false,
        readyFreeShippingThreshold: 0,
        handcraftedFreeShippingThreshold: 0,
        removedNotice: null,
        usOnlyRemovalNotice: null,
        removingKey: null,
        closeTimer: null,
        initRail(config = {}) {
          this.mode = 'rail';
          this.enable = true;
          this.currency = config.currency || this.currency;
          this.cartUrl = config.cartUrl || this.cartUrl;
          this.engravingVariantId = config.engravingVariantId ? String(config.engravingVariantId) : null;
          this.laserArtworkFeeVariantId = config.laserArtworkFeeVariantId ? String(config.laserArtworkFeeVariantId) : null;
          this.freeShippingEnabled = Boolean(config.freeShippingEnabled);
          this.readyFreeShippingThreshold = Number(config.readyFreeShippingThreshold || 0);
          this.handcraftedFreeShippingThreshold = Number(config.handcraftedFreeShippingThreshold || this.readyFreeShippingThreshold || 0);
          this.refresh(false);
        },
        setItem(items) {
          this.listItem = [];
          if (items.items) {
            this.listItem = items.items
          } else {
            this.listItem.push(items);
          }
          this.removedNotice = null;
          this.open();
          if (this.mode === 'rail') {
            this.refresh(true);
          } else {
            this.refresh(false);
          }
        },
        open() {
          this.show = true;
          clearTimeout(this.closeTimer);
          if (this.mode === 'rail') return;
          this.closeTimer = setTimeout(() => {
            this.show = false;
          }, 5000);
        },
        async refresh(openAfterRefresh = false) {
          try {
            const response = await fetch(`${Shopify.routes.root}cart.js`, {
              headers: { Accept: 'application/json' }
            });
            const cart = await response.json();
            this.applyCart(cart);
            if (openAfterRefresh || cart.item_count > 0) this.open();
          } catch (error) {
            console.error('Error:', error);
          }
        },
        applyCart(cart) {
          this.items = cart.items || [];
          this.itemCount = this.displayItemCount(this.items);
          this.totalPrice = cart.total_price || 0;
          this.currency = cart.currency || this.currency;
          this.updateCartCounts(this.itemCount);
        },
        async changeItem(item, quantity) {
          if (!item || this.loading) return;
          const nextQuantity = Math.max(0, quantity);
          const removedTitle = item.product_title || item.title;
          const removedUrl = item.url;
          if (nextQuantity === 0) this.removingKey = item.key;
          this.loading = true;

          try {
            const cartHelper = Alpine.store('xCartHelper');
            if (cartHelper) await cartHelper.waitForCartUpdate();

            window.updatingCart = true;

            const sections = cartHelper
              ? cartHelper.getSectionsToRender().map((section) => section.id)
              : [];
            const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: nextQuantity,
                sections,
                sections_url: window.location.pathname
              })
            });
            const cart = await response.json();

            if (cart.status == '422') return;

            this.applyCart(cart);
            this.removedNotice = nextQuantity === 0 ? { title: removedTitle, url: removedUrl } : null;

            if (cartHelper && cart.sections) {
              await cartHelper.reRenderSections(cart.sections);
              cartHelper.currentItemCount = this.itemCount;
              this.updateCartCounts(this.itemCount);
            }

            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            this.open();
          } catch (error) {
            console.error('Error:', error);
          } finally {
            this.removingKey = null;
            window.updatingCart = false;
            this.loading = false;
          }
        },
        decrease(item) {
          this.changeItem(item, (item.quantity || 0) - 1);
        },
        increase(item) {
          this.changeItem(item, (item.quantity || 0) + 1);
        },
        remove(item) {
          this.changeItem(item, 0);
        },
        formatMoney(amount) {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.currency
          }).format((amount || 0) / 100);
        },
        itemImage(item) {
          return item?.featured_image?.url || item?.image || '';
        },
        itemPrice(item) {
          return this.formatMoney(this.itemPriceWithEngraving(item));
        },
        itemPriceWithEngraving(item) {
          const basePrice = item?.final_price || item?.price || 0;
          return basePrice + this.personalizationChildrenFor(item).reduce((total, child) => {
            return total + (child?.final_price || child?.price || child?.final_line_price || child?.line_price || 0);
          }, 0);
        },
        itemParentKey(item) {
          return item?.parent_relationship?.parent?.key || item?.parent_relationship?.parent_key || item?.parent_key || '';
        },
        isEngravingItem(item) {
          if (!item) return false;
          const variantId = String(item.variant_id || item.id || '');
          return Boolean(variantId) && (
            variantId === this.engravingVariantId ||
            variantId === this.laserArtworkFeeVariantId
          );
        },
        isColorChangeFeeItem(item) {
          return Boolean(item?.properties?._color_change_fee || item?.properties?.['_color_change_fee']);
        },
        engravingChildrenFor(parentItem) {
          if (!parentItem?.key) return [];
          const parentTitles = [
            parentItem.variant_title,
            parentItem.product_title,
            parentItem.title
          ].filter(Boolean).map((title) => String(title).trim());

          return this.items.filter((item) => {
            if (!this.isEngravingItem(item)) return false;
            if (this.itemParentKey(item) === parentItem.key) return true;

            const linkedTitle = item?.properties?.For || item?.properties?.['For'];
            return linkedTitle && parentTitles.includes(String(linkedTitle).trim());
          });
        },
        colorChangeChildrenFor(parentItem) {
          if (!parentItem?.key) return [];
          return this.items.filter((item) => {
            return this.isColorChangeFeeItem(item) && this.itemParentKey(item) === parentItem.key;
          });
        },
        personalizationChildrenFor(parentItem) {
          return [
            ...this.engravingChildrenFor(parentItem),
            ...this.colorChangeChildrenFor(parentItem)
          ];
        },
        visibleItems() {
          return this.items.filter((item) => !this.isEngravingItem(item) && !this.isColorChangeFeeItem(item));
        },
        displayItemCount(items = this.items) {
          return (items || []).reduce((total, item) => {
            if (!item) return total;
            if (this.isEngravingItem(item) || this.itemParentKey(item)) return total;
            return total + (Number(item.quantity) || 0);
          }, 0);
        },
        itemEngravingText(item) {
          const properties = item?.properties || {};
          const match = Object.entries(properties).find(([name, value]) => {
            if (!value || String(name).charAt(0) === '_') return false;
            const normalizedName = String(name).toLowerCase();
            return normalizedName.includes('personal') || normalizedName.includes('engraving') || normalizedName.includes('kaz');
          });
          return match ? match[1] : '';
        },
        itemPersonalizationSelections(item) {
          const properties = item?.properties || {};
          const feeChildren = this.colorChangeChildrenFor(item);
          const selections = [];
          const engravingText = this.itemEngravingText(item);
          const engravingFee = this.engravingChildrenFor(item).reduce((total, child) => {
            return total + (child?.final_price || child?.price || child?.final_line_price || child?.line_price || 0);
          }, 0);

          if (engravingText) {
            selections.push({
              label: 'Engraving',
              shortLabel: 'Engrave',
              value: String(engravingText),
              fee: engravingFee > 0 ? `+${this.formatMoney(engravingFee)}` : ''
            });
          }

          return Object.entries(properties).reduce((result, [name, value]) => {
            const normalizedName = String(name).trim().toLowerCase();
            if (!value || (normalizedName !== 'thread color' && normalizedName !== 'strap color')) return result;

            const feeChild = feeChildren.find((child) => {
              const feeLabel = child?.properties?._color_change_fee || child?.properties?.['_color_change_fee'];
              return String(feeLabel || '').trim().toLowerCase() === normalizedName;
            });
            const feeAmount = feeChild?.final_price || feeChild?.price || feeChild?.final_line_price || feeChild?.line_price || 0;

            selections.push({
              label: String(name),
              shortLabel: normalizedName === 'thread color' ? 'Thread' : 'Strap',
              value: String(value),
              fee: feeAmount > 0 ? `+${this.formatMoney(feeAmount)}` : ''
            });
            return result;
          }, selections);
        },
        itemFulfillmentGroup(item) {
          const group = item?.properties?._fulfillment_group || item?.properties?.['_fulfillment_group'];
          if (group === 'handcrafted-to-order') return 'handcrafted-to-order';
          if (group === 'ready-to-ship') return 'ready-to-ship';
          return '';
        },
        activeFreeShippingGroup() {
          if (this.items.some((item) => this.itemFulfillmentGroup(item) === 'handcrafted-to-order')) return 'handcrafted-to-order';
          if (this.items.some((item) => this.itemFulfillmentGroup(item) === 'ready-to-ship')) return 'ready-to-ship';
          return 'ready-to-ship';
        },
        activeFreeShippingThreshold() {
          return this.activeFreeShippingGroup() === 'handcrafted-to-order'
            ? this.handcraftedFreeShippingThreshold
            : this.readyFreeShippingThreshold;
        },
        activeFreeShippingTotal() {
          const group = this.activeFreeShippingGroup();
          const groupedItems = this.items.filter((item) => this.itemFulfillmentGroup(item) === group);
          const sourceItems = groupedItems.length ? groupedItems : this.items;
          return sourceItems.reduce((total, item) => total + (item.final_line_price || 0), 0);
        },
        freeShippingRemaining() {
          return Math.max(0, this.activeFreeShippingThreshold() - this.activeFreeShippingTotal());
        },
        showFreeShippingMessage() {
          return this.freeShippingEnabled && this.activeFreeShippingThreshold() > 0 && this.itemCount > 0;
        },
        qualifiesForFreeShipping() {
          return this.showFreeShippingMessage() && this.freeShippingRemaining() === 0;
        },
        updateCartCounts(count) {
          const label = count < 100 ? `${count}` : '99+';
          document.querySelectorAll('#cart-icon-bubble .count_item, #mobile-cart-icon-bubble').forEach((el) => {
            el.textContent = label;
            el.dataset.value = count;
            el.classList.remove('hidden');
          });

          const mobileDock = document.getElementById('cart-icon-bubble-mobile-dock');
          if (mobileDock) {
            mobileDock.dataset.value = count;
            const text = mobileDock.querySelector('span') || mobileDock;
            text.textContent = label;
            mobileDock.querySelector('div')?.classList.remove('hidden');
          }
        }
      })
    });
  });
}
